import { useState, useEffect } from "react";
import { FiPlay } from "react-icons/fi";
import GeneratorsTable from "../components/run/GeneratorsTable";
import RunPanel from "../components/run/RunPanel";
import {
  fetchGenerators,
  subscribeToGenerators,
} from "../services/generatorService";

const Run = () => {
  const [generators, setGenerators] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load generators and subscribe to changes at the parent level
  useEffect(() => {
    loadGenerators();

    // Subscribe to real-time updates
    const subscription = subscribeToGenerators(() => {
      loadGenerators();
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const loadGenerators = async () => {
    setLoading(true);
    const { data } = await fetchGenerators();
    setGenerators(data || []);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-10">
          <div className="mb-2 flex items-center gap-3">
            <div className="flex size-10 items-center justify-center rounded-lg bg-primary-100">
              <FiPlay className="size-5 text-primary-600" />
            </div>
            <h1 className="text-4xl font-semibold text-gray-900">
              Run Benchmark
            </h1>
          </div>
          <p className="mt-3 text-lg text-gray-600">
            Configure and execute benchmark tests on your content generators.
          </p>
        </div>

        {/* Generators Management */}
        <div className="mb-10">
          <GeneratorsTable
            generators={generators}
            onGeneratorsChange={loadGenerators}
          />
        </div>

        {/* Run Configuration */}
        <div>
          <RunPanel generators={generators} loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default Run;
